<template>
  <div>
    <!-- v-if="prefijo == enumeraciones.etiquetasDeHTML.Select" -->
    <div class="form-group">
       <multiselect 
        v-model="valorPorDefecto" 
        :options="Puestos"
        select-label=""        
        :show-labels="false"
        :placeholder="placeholder"
        @select="cambioPuesto"
        label="Nombre"
      >
        <span slot="noResult">Sin coincidencias</span>
      </multiselect>
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import comun from '@/../static/js/comun'
  import api from '@/../static/js/api'
  import axios from 'axios'
  import Multiselect from 'vue-multiselect'  

  export default {
    components:{Multiselect},
    data() {
      return {
        enumeraciones,
        comun,
        Puestos: [],
        idDelModelo: null,
        desHabilitaEdicion:true,
        valorPorDefecto: null        
      }
    },
    props: {
      // Nuevos prefijos 
      placeholder: String,

      prefijo: Number,
      
      tipo: {
        Id: Number,
        Nombre: String
      },
      
      idDelInput: String,
      valorDefinido: Number,
      parametros: {AreaId:null,DepartamentoId:null},
      hereda:{
        type:Number,
        default:null
      }
    },
    created() {      
      //this.desHabilitaEdicion = this.hereda != null && this.hereda == -1
      this.cargaCatalogoDePuestos(this.parametros)
    }, 
    mounted() {
      // if(this.valorDefinido == undefined || this.valorDefinido == null)
      //   this.idDelModelo = this.tipo.Id;
      // else
      //   this.idDelModelo = this.valorDefinido; 
      
      // const parametros = {
      //   llave: this.idDelInput,
      //   valor: this.idDelModelo
      // }
      //this.$store.dispatch("A_PJ_Catalogo_Establecer045Puesto", parametros);
    },
    methods: {
      
      cambioPuesto (evento) {
        this.$emit("valorParaElPadre", evento);
      },
      cargaCatalogoDePuestos: function(parametrosDeConsulta) {
        let peticion = {
          PuestoId: this.PuestoId,
          TipoPuestoId: null,
          AreaId: parametrosDeConsulta.AreaId,
          TipoDepartamentoId: parametrosDeConsulta.DepartamentoId,
          conInactivos: false,
          conTipoPuesto: false,
          EsPrueba: this.enumeraciones.EsPrueba,
        }
        axios.post(api.conexion + api.PJ.catalogos.C045Puestos, peticion)
          .then(respuesta => {
            if (respuesta.data.SiHayError) {
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else {
              this.vaciarPuestosAArreglo(respuesta.data.Puestos);                           
              return respuesta.data.Puestos;
            }
          }).catch(e => {
           console.log("No Hay Respuesta del Servidor" + e);
         });

      },
      vaciarPuestosAArreglo(puestos){
        let arregloDePuestos = [];
        puestos.forEach(puesto => {   
          let puestoInstancia = {};
          puestoInstancia.PuestoId = puesto.PuestoId; 
          puestoInstancia.Nombre = puesto.Nombre;       
          arregloDePuestos.push(puestoInstancia);
        });
        this.Puestos = arregloDePuestos;        
      },
      cambiarDatos(evento) { 
        this.idDelModelo = evento.target.value;
        const parametros = {
          llave: this.idDelInput,
          valor: evento.target.value
        }
        
        this.$store.dispatch("A_PJ_Catalogo_Establecer045Puesto", parametros);
        this.$emit("valorParaElPadre", evento);
        
      }      
    }
  }
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.multiselect__option--highlight {
  background: #504f54;
}

.multiselect__option--selected.multiselect__option--highlight{
  background: #007bff;
}
</style>



// WEBPACK FOOTER //
// src/components/PJ/Catalogos/045PuestosBuscador.vue